import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import "./app.scss";
import EmitEvent, {
  PAGE_AFTER,
  PAGE_LEAVE,
  SMOOTH_SCROLLING,
  WHEEL_SCROLLING,
} from "./libs/emit-event";
import "./components/dev-info/dev-info";
import renderSVG from "Libs/render-svg";
import DevInfo from "./components/dev-info/dev-info";
import GridDebug from "./components/grid-debug/debug";
import { Header } from "./components/elements/header/header";
import { ImageLazy } from "./components/system/image-lazy/image-lazy";
import { checkDeviceMobile, getScrollTop } from "./libs/helper";
import { SmoothScrollWheel } from "./components/system/page-scrolling/smooth-scroll-wheel";
import { HtLayout } from "./components/layout/ht-layout";
import { PageTransition } from "./components/system/page-transition/page-transition";
import { Footer } from "./components/elements/footer/footer";
// import {FeatureLogos} from "./components/elements/feature-logos/feature-logos";
import handleFeatureLogo from "./components/elements/feature-logos/c-feature-logo";
import { PageLoading } from "./components/system/page-loading/page-loading";
import { FeatureCareers } from "./components/elements/feature-careers/feature-careers";
import { ShortcodeServicesPage } from "./components/elements/shortcode-services-page/shortcode-services-page";
import { VideoBg } from "./components/system/video-player/video-bg";
import { ElementProjectGallery } from "./components/elements/element-project-gallery/element-project-gallery";
import { FeatureServices } from "./components/elements/feature-services/feature-services";
import { FeatureCases } from "./components/elements/feature-cases/feature-cases";
import { WebglImages } from "./components/elements/webgl-images/webgl-images";
import { FeatureTeams } from "./components/elements/feature-teams/feature-teams";
import { ShortcodeProjectsPage } from "./components/elements/shortcode-projects-page/shortcode-projects-page";
import { ShortcodeProjectsPageMobile } from "./components/elements/shortcode-projects-page/mobile/shortcode-projects-page-mobile";
import { FeatureTeamsMobile } from "./components/elements/feature-teams/mobile/feature-teams-mobile";
import { SingleProduct } from "./components/elements/single-product/single-product";
import { ElementLinkUnderline } from "./components/elements/element-link-underline/element-link-underline";
import { Buttons } from "./components/elements/button/buttons";
import FeatureContactForm from "./components/elements/feature-contact/feature-contact-form";
import { Cookies } from "./components/elements/cookies-alert/cookies";
import { FeatureTestimonial } from "./components/elements/fearture-testimonial/feature-testimonial";
gsap.registerPlugin(ScrollToPlugin);

class App {
  constructor() {
    window.htDatas = {
      session: {},
      page: [],
      animationType: "contentLoaded",
      docTop: 0,
      scrollHeight: 0,
    };

    this.init();
    this.bindEvent();
  }

  init() {
    // new DevInfo("dev");
    new HtLayout();
    new ImageLazy();
    new GridDebug();
    new Header();
    new Footer();
    new Cookies();

    this.featureCareers = new FeatureCareers();
    handleFeatureLogo();
    this.shortCodeServicesPage = new ShortcodeServicesPage();
    this.videoPlayer = new VideoBg();
    this.projectGallery = new ElementProjectGallery();
    this.featureServices = new FeatureServices();
    this.featureCareers = new FeatureCases();
    this.singleProduct = new SingleProduct();

    new Buttons();
    new ElementLinkUnderline();
    new FeatureContactForm();

    if (!checkDeviceMobile()) {
      //  new Cursor();
      new SmoothScrollWheel();
      this.webglImages = new WebglImages();
      this.featureTeams = new FeatureTeams();
      this.shortcodeProjectsPage = new ShortcodeProjectsPage();
    } else {
      this.shortcodeProjectsPageMobile = new ShortcodeProjectsPageMobile();
      this.featureTeamsMobile = new FeatureTeamsMobile();
    }

    renderSVG.initRenderSVG();
    new PageTransition();
    new PageLoading();

    this.FeatureTestimonial = new FeatureTestimonial();
  }

  pageEnter() {
    this.featureCareers = new FeatureCareers();
    handleFeatureLogo();
    this.shortCodeServicesPage = new ShortcodeServicesPage();
    this.videoPlayer = new VideoBg();
    this.projectGallery = new ElementProjectGallery();
    this.featureServices = new FeatureServices();
    this.featureCareers = new FeatureCases();
    this.singleProduct = new SingleProduct();
    new ElementLinkUnderline();
    new FeatureContactForm();

    if (!checkDeviceMobile()) {
      this.webglImages = new WebglImages();
      this.featureTeams = new FeatureTeams();
      this.shortcodeProjectsPage = new ShortcodeProjectsPage();
    } else {
      this.featureTeamsMobile = new FeatureTeamsMobile();
      this.shortcodeProjectsPageMobile = new ShortcodeProjectsPageMobile();
    }

    this.FeatureTestimonial = new FeatureTestimonial();

    renderSVG.renderSvgElement(document.querySelector(".js-pageContent"));
  }

  pageLeave() {
    this.featureCareers.removeEvents && this.featureCareers.removeEvents();
    this.shortCodeServicesPage.removeEvents &&
      this.shortCodeServicesPage.removeEvents();
    this.videoPlayer.removeEvent && this.videoPlayer.removeEvent();
    this.projectGallery.removeEvent && this.projectGallery.removeEvent();
    this.singleProduct.removeEvent && this.singleProduct.removeEvent();

    if (!checkDeviceMobile()) {
      this.webglImages.removeEvent && this.webglImages.removeEvent();
      this.featureTeams.removeEvent && this.featureTeams.removeEvent();
      this.shortcodeProjectsPage.removeEvent &&
        this.projectGallery.removeEvent();
    } else {
      this.featureTeamsMobile.removeEvent &&
        this.featureTeamsMobile.removeEvent();
      this.shortcodeProjectsPageMobile.removeEvent &&
        this.shortcodeProjectsPageMobile.removeEvent();
    }

    this.clearObs();
  }

  clearObs() {
    this.featureCareers = null;
    this.shortCodeServicesPage = null;
    this.videoPlayer = null;
    this.projectGallery = null;
    this.featureServices = null;
    this.featureCareers = null;
    this.webglImages = null;
    this.featureTeams = null;
    this.singleProduct = null;
    this.FeatureTestimonial = null;

    if (checkDeviceMobile()) {
      this.featureTeamsMobile = null;
      this.shortcodeProjectsPageMobile = null;
    }
  }

  bindEvent() {
    EmitEvent.on(PAGE_AFTER, this.pageEnter.bind(this));
    EmitEvent.on(PAGE_LEAVE, this.pageLeave.bind(this));
    if (checkDeviceMobile()) {
      window.addEventListener("scroll", () => {
        EmitEvent.emit(SMOOTH_SCROLLING, { instance: getScrollTop() });
        EmitEvent.emit(WHEEL_SCROLLING, { instance: getScrollTop() });
      });
    }
  }
}

new App();
